
import React from "react";
import { FormControl, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { LucideIcon } from "lucide-react";

interface AuthFormFieldProps {
  field: any;
  label: string;
  placeholder: string;
  type: string;
  autoComplete: string;
  icon: LucideIcon;
  accountType?: string;
}

const AuthFormField: React.FC<AuthFormFieldProps> = ({
  field,
  label,
  placeholder,
  type,
  autoComplete,
  icon: Icon,
  accountType
}) => {
  // Use startup-specific placeholder for email field when account type is startup
  const getPlaceholder = () => {
    if (type === "email" && accountType === "startup") {
      return "teenvisor@gmail.com (use your startup email)";
    }
    return placeholder;
  };

  return (
    <FormItem className="space-y-2 md:space-y-3">
      <FormLabel className="text-sm md:text-base font-semibold">{label}</FormLabel>
      <FormControl>
        <div className="relative">
          <Icon className="absolute left-3 md:left-4 top-1/2 transform -translate-y-1/2 h-4 w-4 md:h-5 md:w-5 text-primary" />
          <Input
            placeholder={getPlaceholder()}
            type={type}
            autoComplete={autoComplete}
            className="pl-10 md:pl-12 h-12 md:h-14 border-border/50 focus:border-primary rounded-lg md:rounded-xl text-sm md:text-base font-medium bg-background/50 backdrop-blur-sm"
            {...field}
          />
        </div>
      </FormControl>
      <FormMessage className="text-red-600 font-medium text-xs md:text-sm" />
    </FormItem>
  );
};

export default AuthFormField;
